<div class="modal-header p-0 d-flex justify-content-end">
    <div class="close-button" [mat-dialog-close]="false"><img src="../../../assets/images/Cancel.svg" alt="" srcset=""></div>
</div>
<div class="modal-body d-flex justify-content-center align-items-center">
    <ngb-carousel class="w-100" [interval]="0" activeId="1">
        <ng-template ngbSlide *ngFor="let image of data.images">
            <div class="mx-auto">
                <img *ngIf="isImage(image)" [src]="image" class="media">
                <video *ngIf="isVideo(image)" [src]="image" class="media" controls></video>
            </div>
        </ng-template>
    </ngb-carousel>
</div>